import { ThemeProvider } from '@synoptic/ui-kit/theme/theme-provider.js';
import { useRef } from 'react';
import { useRouteLoaderData } from 'react-router';

export const RootThemeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const loaderData = useRouteLoaderData('root') as {
    colorScheme?: 'dark' | 'light';
  };

  const abortControllerRef = useRef<AbortController>(null);

  return (
    <ThemeProvider
      mode={loaderData?.colorScheme}
      onChange={(theme) => {
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        const formData = new FormData();
        formData.set('color-scheme', theme);
        fetch('/api/set-color-scheme', {
          method: 'POST',
          body: formData,
          signal: abortController.signal,
        }).catch((err) => {
          console.error('Failed to set color scheme', err);
        });
      }}
    >
      {children}
    </ThemeProvider>
  );
};
